module.exports = __webpack_public_path__ + "static/young-leader-photo-stephanie_melnik-15073f73a58f32445dc6967dd6836d3a.jpg";